module.exports = __webpack_public_path__ + "static/media/alert-icon.ce589575.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dublin-express/alert-icon.svg
// module id = 704
// module chunks = 0